import { render, staticRenderFns } from "./JeckAdd.vue?vue&type=template&id=ddb96cc2"
import script from "./JeckAdd.vue?vue&type=script&lang=js"
export * from "./JeckAdd.vue?vue&type=script&lang=js"
import style0 from "./JeckAdd.vue?vue&type=style&index=0&id=ddb96cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports